import { connect } from 'react-redux';

import {
    setGrid,
    setGridItems,
    setSorting,
    selectGridItem,
    deleteGrid,
    setGridPagination,
} from '../store/actions/gridStore';
import { getSelectedItems, getFilteredItems, getPaginationOptions } from './selectors/gridSelectors';
import GridComponent from '../components/core/GridComponent/GridComponent';

const mapStateToProps = (state, props) => ({
    ...props,
    selectedItems: getSelectedItems(state, props),
    gridItems: getFilteredItems(state, props),
    paginationOptions: getPaginationOptions(state, props),
});

const mapDispatchToProps = {
    setGrid,
    setGridItems,
    setSorting,
    setGridPagination,
    selectGridItem,
    deleteGrid,
};

const mergeProps = (
    { name, ...stateProps },
    { setGrid, deleteGrid, setGridItems, setSorting, setGridPagination, ...dispatchProps },
) => ({
    ...stateProps,
    ...dispatchProps,
    name,
    setGrid: () => setGrid(name),
    setGridItems: (items) => setGridItems(name, items),
    setSorting: (sortBy) => setSorting(name, sortBy),
    setGridPagination: (options) => setGridPagination(name, options),
    deleteGrid: () => deleteGrid(name),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(GridComponent);



// WEBPACK FOOTER //
// ./src/containers/GridContainer.js